import * as React from "react";
import { WWTForm } from "./WWTForm";

interface IChangeAddressModalProps {
  onClose: () => void;
  onConfirm?: () => void;
  isSkippable?: boolean;
  onSkip?: () => void;
}

export function AddAddressModal({
  onClose,
  onConfirm,
  isSkippable,
  onSkip,
}: IChangeAddressModalProps) {
  React.useEffect(() => {
    return () => {
      onClose();
    };
  }, [onClose]);

  return (
    <div className="from-tablet:w-[755px]">
      <WWTForm
        isSkippable={isSkippable}
        onClose={onClose}
        onConfirm={onConfirm}
        onSkip={onSkip}
      />
    </div>
  );
}
